import { createRouter, createWebHistory } from 'vue-router';
import BuildsView from '../views/BuildsView.vue';
import BuildDetailView from '../views/BuildDetailView.vue';
import LoginView from '../views/LoginView.vue';
import ProfileView from '../views/ProfileView.vue';
import { useAuthStore } from '../stores/auth';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: { requiresAuth: false },
    },
    {
      path: '/cli-login',
      name: 'cli-login',
      component: () => import('../views/CliLoginView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/',
      name: 'builds',
      component: BuildsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/builds/:id',
      name: 'build-detail',
      component: BuildDetailView,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: '/schedules',
      name: 'schedules',
      component: () => import('../views/SchedulesDashboardView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/workers',
      name: 'workers',
      component: () => import('../views/WorkersView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/repositories',
      name: 'repositories',
      component: () => import('../views/RepositoryBrowserView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/repositories/:slug/:repoName',
      name: 'repository-detail',
      component: () => import('../views/RepositoryDetailView.vue'),
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: '/profile',
      name: 'profile',
      component: ProfileView,
      meta: { requiresAuth: true },
    },
    {
      path: '/status',
      name: 'status',
      component: () => import('../views/StatusView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/pod-templates',
      name: 'pod-templates',
      component: () => import('../views/PodTemplatesView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/insights',
      name: 'insights',
      component: () => import('../views/InsightsView.vue'),
      meta: { requiresAuth: true },
    },
    // Organization-scoped builds dashboard. Defined last so static routes
    // above (e.g. /profile, /insights) take precedence — Vue Router 4
    // also ranks static segments above dynamic ones, so this is safe
    // even if the order ever changes.
    {
      path: '/:orgSlug',
      name: 'org-builds',
      component: BuildsView,
      props: true,
      meta: { requiresAuth: true },
    },
  ],
});

router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore();

  if (!authStore.initialized) {
    next();
    return;
  }

  const requiresAuth = to.meta.requiresAuth !== false;

  if (requiresAuth && !authStore.isAuthenticated) {
    next({ name: 'login' });
  } else if (to.name === 'login' && authStore.isAuthenticated) {
    next({ name: 'builds' });
  } else {
    next();
  }
});

export default router;
